import { memo } from 'react';
import styled, { css } from 'styled-components';
import { size, spacing, borderRadius, colors, typography } from '@izettle/otto';
import { CheckboxDecorative, RadioButtonDecorative } from '../../selectors/index.js';
import { FOCUS_BORDER_WIDTH } from '../helpers/constants.js';
import { InputIcon } from '../../input-icon/components.js';

const FocusRemover = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__FocusRemover",
  componentId: "zettle__sc-tblw0x-0"
})(["width:100%;height:", ";max-height:", ";display:flex;outline:none;min-width:0;box-sizing:border-box;pointer-events:none;padding:0 ", ";align-items:center;border-radius:", ";&:focus{border:", " solid ", ";padding:0 calc(", " - ", ");}"], size.large, size.large, spacing.small, borderRadius.medium, FOCUS_BORDER_WIDTH, colors.action.primary.border.default, spacing.small, FOCUS_BORDER_WIDTH));
const SelectOptionContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectOptionContainer",
  componentId: "zettle__sc-tblw0x-1"
})(["display:flex;outline:none;background:none;border:none;cursor:pointer;min-height:fit-content;", " ", " justify-content:", ";"], _ref => {
  let {
    disabled
  } = _ref;
  return !disabled && css`
      &:hover {
        background: ${colors.background.groupedSecondary};
      }
      &:active {
        background: ${colors.background.groupedSecondary};
      }
    `;
}, _ref2 => {
  let {
    isSelected
  } = _ref2;
  return isSelected ? typography.regularBold : typography.regular;
}, _ref3 => {
  let {
    isMultiple
  } = _ref3;
  return isMultiple ? "flex-start" : "space-between";
}));
const SelectOptionContent = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectOptionContent",
  componentId: "zettle__sc-tblw0x-2"
})(["display:flex;align-items:flex-start;flex-direction:column;justify-content:center;flex:1;width:100%;min-width:0;"]));
const SelectOptionDescription = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectOptionDescription",
  componentId: "zettle__sc-tblw0x-3"
})(["text-overflow:ellipsis;display:block;white-space:nowrap;overflow:hidden;width:100%;text-align:left;", ""], typography.smallSecondary));
const SelectOptionText = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectOptionText",
  componentId: "zettle__sc-tblw0x-4"
})(["text-overflow:ellipsis;display:block;text-align:left;white-space:nowrap;overflow:hidden;width:100%;", ""], _ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled && `
      color: ${colors.text.disabled};
    `;
}));
const SelectCheckbox = /*#__PURE__*/memo(styled(CheckboxDecorative).withConfig({
  displayName: "styles__SelectCheckbox",
  componentId: "zettle__sc-tblw0x-5"
})(["margin-right:", ";"], spacing.xSmall));
const SelectRadioButton = /*#__PURE__*/memo(styled(RadioButtonDecorative).withConfig({
  displayName: "styles__SelectRadioButton",
  componentId: "zettle__sc-tblw0x-6"
})(["margin-right:", ";"], spacing.xSmall));
const StyledInputIcon = /*#__PURE__*/memo(styled(InputIcon).withConfig({
  displayName: "styles__StyledInputIcon",
  componentId: "zettle__sc-tblw0x-7"
})(["padding-right:0;padding-left:", ";color:", ";"], spacing.xSmall, colors.icon.action));
const StyledImage = /*#__PURE__*/memo(styled.img.withConfig({
  displayName: "styles__StyledImage",
  componentId: "zettle__sc-tblw0x-8"
})(["padding:0;height:", ";width:", ";border-radius:", ";margin-right:", ";"], size.small, size.small, borderRadius.medium, spacing.xSmall));

export { FocusRemover, SelectCheckbox, SelectOptionContainer, SelectOptionContent, SelectOptionDescription, SelectOptionText, SelectRadioButton, StyledImage, StyledInputIcon };
//# sourceMappingURL=styles.js.map
